import React, { useState } from "react";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { postRequest } from "../../util/request/request";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  console.log(username, password);
  const handleLogin = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!username || !password) {
      setErrorMessage("Please enter both username and password.");
      return;
    }

    const result = await postRequest({
      subLink: "auth/login",
      data: { username: username, password: password },
    });
    console.log(result);
    if (result.message === "Login successful!") {
      // Store the token in cookies
      document.cookie = `authToken=${
        result.token
      }; path=/; Secure; SameSite=Strict; max-age=${24 * 60 * 60}`;

      console.log(document.cookie);
      return navigate("/authorization");
      // if (result.status === "success") {
      //   //   setShowFinishPage(result);
      // } // Mock login logic
      // if (username === "admin" && password === "password") {
      //   alert("Login successful!");
      //   setErrorMessage("");
      // } else {
      //   setErrorMessage("Invalid username or password.");
      // }
    }
    {
      setErrorMessage("Incorrect username or password");
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 380,
        mx: "auto", // Center horizontally
        mt: 10, // Add vertical margin
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
      }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Login
      </Typography>
      <form onSubmit={handleLogin}>
        <Box sx={{ mb: 2 }}>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>
        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#007bff",
            ":hover": { backgroundColor: "#0056b3" },
          }}
        >
          Login
        </Button>
      </form>
    </Box>
  );
};

export default Login;
